import { get } from "lodash";

export interface Konf {
  [key: string]: any;
}

export function getConfigField<T>(
  konf: Konf,
  field: string | string[],
  defaultValue: T
): T {
  return get(konf, field, defaultValue);
}

export function getClientId(konf: Konf, client: string) {
  return getConfigField(konf, ["clients", client], "");
}

export function getVisaHost(konf: Konf) {
  return getConfigField(konf, ["visa.host"], "");
}

export function getCookieDomain(konf: Konf) {
  return getConfigField(konf, ["cookieDomain"], "");
}

export function getCookieDomainDeprecated(konf: Konf) {
  return getConfigField(konf, ["cookieDomainDeprecated"], "");
}

export function getAppUrl(konf: Konf, client: string) {
  return getConfigField(konf, ["url", client], "");
}

export function getApiHost(konf: Konf, api: string) {
  return getConfigField(konf, ["api", api], "");
}
